import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { Button } from '@grandvisionhq/common';
import { Types } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { useStoreFinderContext } from '../../../context/StoreFinder/context.js';
import '@swc/helpers';
import '@grandvisionhq/locations';
import { areServicesAvailable } from '../../../utils/store-utils.js';
import 'lodash/deburr';
import '../../../context/StoreFinderSlots/context.js';
import { storesLocatorResultEvent } from '../../../data-layer/actions.js';
import { useBookAppointmentUrl } from '../../../hooks/use-book-appointment-url.js';

const BookAppointmentButtonContainer = ({ store: store1 , view , isPreferredStore ,  })=>{
    const { getLabel  } = useIntl();
    const { stores , urls  } = useStoreFinderContext();
    const { globalStoreId  } = store1;
    const bookAppointmentUrl = useBookAppointmentUrl(urls === null || urls === void 0 ? void 0 : urls.bookAppointment, store1);
    const showBookAppointmentCTA = areServicesAvailable(store1, [
        Types.ServicesNotAvailable.APPOINTMENTS, 
    ]);
    const onStoresLocatorResultEvent = React.useCallback(({ store , preferredStore , interaction , searchPosition , searchResults  })=>{
        const dataLayerEvent = storesLocatorResultEvent({
            interaction,
            store,
            preferredStore,
            searchPosition,
            searchResults
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    const onBookAppointmentButtonClickHandler = React.useCallback(()=>{
        onStoresLocatorResultEvent(view === 'list' ? {
            store: store1,
            preferredStore: isPreferredStore,
            interaction: 'book appointment click',
            searchPosition: stores.indexOf(store1) + 1
        } : {
            store: store1,
            preferredStore: isPreferredStore,
            interaction: 'map click - book appointment',
            searchResults: stores.length
        });
        if (bookAppointmentUrl) {
            try {
                window.location.assign(bookAppointmentUrl);
            } catch (error) {
                console.error('Invalid book appointment URL:', error);
            }
        } else {
            console.error('Book appointment URL is undefined or null');
        }
    }, [
        onStoresLocatorResultEvent,
        view,
        store1,
        isPreferredStore,
        stores,
        bookAppointmentUrl
    ]);
    if (!showBookAppointmentCTA) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Button, {
        onClick: onBookAppointmentButtonClickHandler,
        variant: "solid",
        size: "small",
        "data-t": `book-appointment-${globalStoreId}`,
        caption: getLabel('stores.page.storeGroup.action.bookAppointment')
    });
};

export { BookAppointmentButtonContainer as default };
//# sourceMappingURL=BookAppointmentButtonContainer.js.map
